import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { api } from "src/Basic/ApiFetch";
import { Captcha } from "src/Components/Captcha/Captcha";
import {
  showGlobalMessageBox,
  getGlobalServerConfig
} from "src/Route/RootMiddleware";
import { DropDownListWithValue } from "src/Components/Dropdowns/DropDownListWithValue";
import RadioBoxList from 'src/Components/Input/RadioBoxList';
import { validateID } from 'src/Basic/CommonService';
import TextInputForm from 'src/Components/Input/TextInputForm';
import { getCaptchaService } from "src/HomePage/CaptCha.service";
import { DropDown } from "src/HomePage/DropDown.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const Register = ({ returnLogin }) => {
  const initCaptchaEncode = { CaptchaEncode: "" };
  const [captchaTxt, setCaptcha] = useState(initCaptchaEncode);
  const [data, setData] = useState({
    IDENTITY_TYPE: "",
    APPLICANT_TYPE: "",
    AGENT_TYPE: "",
    OWNER_NAME: "",
    USER_NAME: "",
    USER_IDENTIFICATION: "",
    USER_TEL: "",
    USER_FAX: "",
    USER_EMAIL: "",
    USER_ADDR_COUNTY: "",
    USER_ADDR_TOWN: "",
    USER_ADDR_DESC: "",
    OFFICE_NAME: "",
    USER_PWD: "",
    USER_PWD_CONFIRM: "",
    Captcha: ""
  });
  const [countyList, setCountyList] = useState([]); //宣告縣市清單
  const [townList, setTownList] = useState([{ value: "", text: "請選擇鄉鎮市區" }]); //宣告鄉鎮市清單
  const [agentTypeShow, setAgentTypeShow] = useState(false); //宣告代理人類型欄位是否顯示
  const [identityTypeShow, setIdentityTypeShow] = useState(true); //宣告依附身分類型的相關欄位是否顯示
  const [registerSuccess, setRegisterSuccess] = useState(false); //註冊是否成功  
  const [showUserPwd, setShowUserPwd] = useState(false); //是否顯示設定登入密碼   
  const [showUserPwdConfirm, setShowUserPwdConfirm] = useState(false); //是否顯示確認登入密碼

  //重發註冊信件
  const [timeLeft, setTimeLeft] = useState(60); // 初始倒數時間60秒
  const [isRunning, setIsRunning] = useState(false); // 控制計時是否開始


  // 頁面初始化
  useEffect(() => {
    getCaptcha();
    fetchCountyList();
  }, []);

  // 取得縣市清單
  const fetchCountyList = async () => {
    const counties = await DropDown.getCountyList();
    setCountyList(counties);
  };

  /**
   * 取得鄉鎮市清單
   * @param {*} countyCode 縣市代碼
   */
  const fetchTownList = async (countyCode) => {
    const towns = await DropDown.getTownList(countyCode);
    setTownList(towns);
  };



  //取得驗證碼
  const getCaptcha = async (e) => {
    if (e) e.preventDefault();
    const captchaData = await getCaptchaService();
    if (captchaData) {
      setCaptcha(captchaData);
    }
  };

  //欄位驗證
  const validateField = Yup.object().shape({
    IDENTITY_TYPE: Yup.string().required("請選擇身分類型"),
    APPLICANT_TYPE: Yup.string().when("IDENTITY_TYPE", {
      is: "1",
      then: (schema) => schema.required("請選擇申請人類型"),
    }),
    AGENT_TYPE: Yup.string().when("APPLICANT_TYPE", {
      is: "2",
      then: (schema) => schema.required("請選擇代理人類型"),
    }),
    USER_NAME: Yup.string()
      .max(50, "長度不得超過50個字")
      .when("IDENTITY_TYPE", {
        is: "1",
        then: (schema) => schema.required("請輸入姓名"),
        otherwise: (schema) => schema.required("請輸入公司名稱"),
      }),
    USER_IDENTIFICATION: Yup.string()
      .when("IDENTITY_TYPE", {
        is: "1",
        then: (schema) => schema.required("請輸入身份證字號/統一證號").test("is-valid-taiwan-id", "無效的格式", validateID),
        otherwise: (schema) => schema.required("請輸入統一編號"),
      }),

    OWNER_NAME: Yup.string()
      .max(50, "長度不得超過50個字")
      .when("IDENTITY_TYPE", {
        is: "2",
        then: (schema) => schema.required("請輸入姓名"),
        otherwise: (schema) => schema,
      }),
    USER_TEL: Yup.string()
      .max(50, "長度不得超過50個字")
      .required("請輸入聯絡電話"),
    USER_FAX: Yup.string()
      .max(50, "長度不得超過50個字"),
    USER_EMAIL: Yup.string()
      .email("請輸入正確的email格式")
      .max(100, "長度不得超過100個字")
      .required("請輸入e-mail"),
    USER_ADDR_COUNTY: Yup.string().required("請選擇縣市"),
    USER_ADDR_TOWN: Yup.string().required("請選擇鄉鎮市"),
    USER_ADDR_DESC: Yup.string()
      .max(200, "長度不得超過200個字")
      .required("請輸入詳細地址"),
    OFFICE_NAME: Yup.string().when("APPLICANT_TYPE", {
      is: "2",
      then: (schema) => schema
        .required("請輸入事務所名稱")
        .max(100, "長度不得超過100個字"),
      otherwise: (schema) => schema
    }),
    USER_PWD: Yup.string()
      .required("請輸入密碼")
      .min(8, "密碼必須超過8個字元")
      .max(20, "密碼不得超過20個字元")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/,
        "密碼必須含大、小寫英文及數字，不可包含特殊字元，如_， @， #， $， %， ^， &， *等"
      ),
    USER_PWD_CONFIRM: Yup.string()
      .oneOf([Yup.ref("USER_PWD"), null], "確認密碼需與密碼一致")
      .required("請輸入確認密碼"),
    Captcha: Yup.string().required("請輸入驗證碼")
  });


  /**
   * 身分類型Change事件
   * @param {*} type 身分類型
   * @param {*} setFieldValue 設置欄位的值
   * @param {*} validateForm  驗證
   */
  const identityTypeChangeEvent = async (type, setFieldValue, validateForm) => {
    if (type === "2") { //2為法人
      setIdentityTypeShow(false);
      setAgentTypeShow(false);
      setFieldValue("APPLICANT_TYPE", "");
      setFieldValue("AGENT_TYPE", "");
      setFieldValue("OFFICE_NAME", "");
    } else {
      setIdentityTypeShow(true);
      setFieldValue("USER_NAME", "");
      setFieldValue("USER_IDENTIFICATION", "");
    }

    setFieldValue("OWNER_NAME", "");

    //切換身分類型能即時更新驗證
    setTimeout(() => {
      validateForm();
    }, 0);
  }

  // 申請人類型Change事件
  const applicantTypeChangeEvent = async (type, setFieldValue) => {
    if (type === "1") { //1為自行申請
      setAgentTypeShow(false);
      setFieldValue("AGENT_TYPE", "");
      setFieldValue("OFFICE_NAME", "");
    } else {
      setAgentTypeShow(true);
    }
  }

  // 發送註冊請求
  const register = async (data) => {
    let registerData = { ...data, url: window.location.href };
    registerData.CaptchaEncoded = captchaTxt.CaptchaEncode;
    let url = getGlobalServerConfig().backEndUrl.get() + 'Register/Register/';
    let response = await api.Post(url, JSON.stringify(registerData), null, true);
    if (response.ok) {
      let responseJson = (await response.json());
      if (responseJson.success) {
        showGlobalMessageBox(responseJson.message);
        setRegisterSuccess(true);   //顯示註冊成功畫面
      } else {
        showGlobalMessageBox(responseJson.message);
      }
    }

  };

  useEffect(() => {
    let timer;
    if (isRunning && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft(prevTime => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsRunning(false); // 倒數結束，開放按鈕
    }

    return () => clearInterval(timer); // 清理定時器
  }, [isRunning, timeLeft]);

  const startCountdown = () => {
    setIsRunning(true);
    setTimeLeft(60); // 重置時間為 60 秒
  };

  var sendTime;
  const ReSendMail = async (email) => {
    if (isRunning) {
      return;
    }
    let url = getGlobalServerConfig().backEndUrl.get() + 'Register/ReSendRegisterSuccessMail/';
    let data = {
      USER_ID: "",
      email: email,
      sendTime: sendTime,
      url: window.location.href
    };


    let response = await api.Post(url, JSON.stringify(data), null, true);
    if (response.ok) {
      let responseJson = (await response.json());
      if (responseJson.success) {
        showGlobalMessageBox(responseJson.message);
        startCountdown();
      } else {
        showGlobalMessageBox(responseJson.message);
      }
    }
  }

  // 頁面內容
  return (
    <div className="login_content_right_box_width">
      <div className="register_box">
        <Formik
          initialValues={data}
          validationSchema={validateField}
          onSubmit={(data) => register(data)}
        >
          {(props) => {
            const {
              values,
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              setFieldValue,
              validateForm,
            } = props;
            return (!registerSuccess ?
              <form onSubmit={handleSubmit}>
                <div className="login_box_header">
                  <div className="login_box_headline me-auto">註冊</div>
                  <div className="login_box_btn" onClick={() => returnLogin()}>前往登入</div>
                </div>
                <div className="login_box_input">
                  <div className="login_box_txt">
                    身分類型
                    <span style={{ color: "red" }}>
                      (註冊後無法更改)
                    </span>
                  </div>
                  <div className="flex_center">
                    <RadioBoxList
                      group='IDENTITY_TYPE'
                      valueField='id'
                      textField='name'
                      data={[
                        { id: "1", name: '自然人(可綁定憑證類型: 自然人憑證, 行動自然人憑證, 投審司專屬憑證)' },
                        { id: "2", name: '法人(可綁定憑證類型: 工商憑證, 投審司專屬憑證)' }
                      ]}
                      onChange={(e) => {
                        setFieldValue('IDENTITY_TYPE', e.value);
                        identityTypeChangeEvent(e.value, setFieldValue, validateForm);
                      }}
                      error={errors.IDENTITY_TYPE}
                      style={{ display: "block" }}
                    />
                  </div>
                  {identityTypeShow && (<div>
                    <div className="login_box_txt">申請人類型</div>
                    <div className="flex_center">
                      <RadioBoxList
                        group='APPLICANT_TYPE'
                        valueField='id'
                        textField='name'
                        data={[
                          { id: "1", name: '自行申請' },
                          { id: "2", name: '委託代理人' }
                        ]}
                        onChange={(e) => {
                          setFieldValue('APPLICANT_TYPE', e.value);
                          applicantTypeChangeEvent(e.value, setFieldValue);
                        }}
                        error={errors.APPLICANT_TYPE}
                      />
                    </div>
                  </div>)}
                  {agentTypeShow && (<div>
                    <div className="login_box_txt">代理人類型</div>
                    <RadioBoxList
                      group='AGENT_TYPE'
                      valueField='id'
                      textField='name'
                      data={[
                        { id: "1", name: '非會計師或律師' },
                        { id: "2", name: '為會計師或律師' }
                      ]}
                      onChange={(e) => setFieldValue('AGENT_TYPE', e.value)}
                      error={errors.AGENT_TYPE}
                    />
                  </div>)}
                  {identityTypeShow ? (
                    <div >
                      <div className="login_box_txt" >
                        <div className="login_box_txt">
                          {values.APPLICANT_TYPE == "1"
                            ? "投資人姓名"
                            : "代理人姓名"} (需與憑證一致)</div>
                      </div>
                      <TextInputForm
                        onChange={handleChange}
                        value={values.USER_NAME}
                        name="USER_NAME"
                        onBlur={handleBlur}
                        error={errors.USER_NAME}
                        placeholder="請輸入姓名"
                      />
                    </div>
                  ) : (
                    <div >
                      <div className="login_box_txt">公司名稱</div>
                      <TextInputForm
                        onChange={handleChange}
                        value={values.USER_NAME}
                        name="USER_NAME"
                        onBlur={handleBlur}
                        error={errors.USER_NAME}
                        placeholder="請輸入公司名稱"
                      />
                    </div>
                  )}
                  {identityTypeShow ? (
                    <div >
                      <div className="login_box_txt">身分證字號/統一證號</div>
                      <TextInputForm
                        onChange={handleChange}
                        value={values.USER_IDENTIFICATION}
                        name="USER_IDENTIFICATION"
                        onBlur={handleBlur}
                        error={errors.USER_IDENTIFICATION}
                        placeholder="請輸入身分證字號/統一證號"
                      />
                    </div>
                  ) : (
                    <div >
                      <div className="login_box_txt">統一編號</div>
                      <TextInputForm
                        onChange={handleChange}
                        value={values.USER_IDENTIFICATION}
                        name="USER_IDENTIFICATION"
                        onBlur={handleBlur}
                        error={errors.USER_IDENTIFICATION}
                        placeholder="請輸入統一編號"
                      />
                    </div>
                  )}
                  {!identityTypeShow && (<div>
                    <div className="login_box_txt">姓名</div>
                    <TextInputForm
                      onChange={handleChange}
                      value={values.OWNER_NAME}
                      name="OWNER_NAME"
                      onBlur={handleBlur}
                      error={errors.OWNER_NAME}
                      placeholder="請輸入姓名"
                    />
                  </div>)}
                  <div className="login_box_txt">聯絡電話</div>
                  <TextInputForm
                    onChange={handleChange}
                    value={values.USER_TEL}
                    name="USER_TEL"
                    onBlur={handleBlur}
                    error={errors.USER_TEL}
                    placeholder="請輸入聯絡電話"
                  />
                  <div className="login_box_txt">傳真號碼</div>
                  <TextInputForm
                    onChange={handleChange}
                    value={values.USER_FAX}
                    name="USER_FAX"
                    onBlur={handleBlur}
                    error={errors.USER_FAX}
                    placeholder="請輸入傳真號碼"
                  />
                  <div className="login_box_txt">e-mail</div>
                  <TextInputForm
                    onChange={handleChange}
                    value={values.USER_EMAIL}
                    name="USER_EMAIL"
                    onBlur={handleBlur}
                    error={errors.USER_EMAIL}
                    placeholder="請輸入e-mail"
                    autoUppercase={false}
                  />
                  <div className="login_box_txt">文件送達地址</div>
                  <div className="flex">
                    <div className="col margin_xr10">
                      <DropDownListWithValue
                        value={data.USER_ADDR_COUNTY}
                        data={countyList}
                        name="USER_ADDR_COUNTY"
                        textField="text"
                        dataItemKey="value"
                        className="form_control_dropDownList"
                        error={errors.USER_ADDR_COUNTY}
                        onChange={(e) => {
                          setFieldValue('USER_ADDR_COUNTY', e.value.value);
                          setData({
                            ...data,
                            USER_ADDR_COUNTY: e.value.value
                          });
                          fetchTownList(e.value.value);
                        }}
                      />
                    </div>
                    <div className="col">
                      <DropDownListWithValue
                        value={data.USER_ADDR_TOWN}
                        data={townList}
                        name="USER_ADDR_TOWN"
                        textField="text"
                        dataItemKey="value"
                        className="form_control_dropDownList"
                        error={errors.USER_ADDR_TOWN}
                        onChange={(e) => {
                          setFieldValue('USER_ADDR_TOWN', e.value.value);
                          setData({
                            ...data,
                            USER_ADDR_TOWN: e.value.value
                          });
                        }}
                      />
                    </div>
                  </div>
                  <TextInputForm
                    onChange={handleChange}
                    value={values.USER_ADDR_DESC}
                    name="USER_ADDR_DESC"
                    onBlur={handleBlur}
                    error={errors.USER_ADDR_DESC}
                    placeholder="詳細地址"
                  />
                  {agentTypeShow && (<div>
                    <div className="login_box_txt">事務所名稱 (如無請填寫自行執業)</div>
                    <div className="margin_t10"></div>
                    <TextInputForm
                      onChange={handleChange}
                      value={values.OFFICE_NAME}
                      name="OFFICE_NAME"
                      onBlur={handleBlur}
                      error={errors.OFFICE_NAME}
                      placeholder="請輸入事務所名稱"
                    />

                  </div>)}
                  <div className="h_line"></div>
                  <div className="login_box_txt">設定登入密碼</div>
                  <div className="flex">
                    <div style={{ width: "100%" }}>
                      <TextInputForm
                        onChange={handleChange}
                        value={values.USER_PWD}
                        name="USER_PWD"
                        onBlur={handleBlur}
                        error={errors.USER_PWD}
                        placeholder="請輸入密碼"
                        readOnly={false}
                        type={showUserPwd ? "text" : "password"}
                        autoUppercase={false}
                      />
                    </div>
                    <FontAwesomeIcon
                      className="margin_eye"
                      style={{ cursor: "pointer" }}
                      icon={showUserPwd ? faEyeSlash : faEye}
                      onClick={() => setShowUserPwd(!showUserPwd)}
                    />
                  </div>
                  <div className="login_box_txt">確認登入密碼</div>
                  <div className="flex">
                    <div style={{ width: "100%" }}>
                      <TextInputForm
                        onChange={handleChange}
                        value={values.USER_PWD_CONFIRM}
                        name="USER_PWD_CONFIRM"
                        onBlur={handleBlur}
                        error={errors.USER_PWD_CONFIRM}
                        placeholder="請再次輸入密碼"
                        readOnly={false}
                        type={showUserPwdConfirm ? "text" : "password"}
                        autoUppercase={false}
                      />
                    </div>
                    <FontAwesomeIcon
                      className="margin_eye"
                      style={{ cursor: "pointer" }}
                      icon={showUserPwdConfirm ? faEyeSlash : faEye}
                      onClick={() => setShowUserPwdConfirm(!showUserPwdConfirm)}
                    />
                  </div>
                  <div className="login_box_txt">輸入驗證碼</div>

                  <div className="flex">
                    <div className="me-lg-auto-width">
                      <TextInputForm
                        onChange={handleChange}
                        value={values.Captcha}
                        name="Captcha"
                        onBlur={handleBlur}
                        error={errors.Captcha}
                        placeholder="請輸入驗證碼"
                        autoUppercase={false}
                      />
                    </div>
                    <div className="flex_center">
                      <div className="margin_xl10">
                        {captchaTxt.Img && (
                          <Captcha
                            Img={captchaTxt.Img}
                            GetCaptcha={getCaptcha}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <button type="submit" className="blue_common_button">註冊</button>
              </form>
              :
              <>
                <div class="text-center" >
                  <div class="font_18_500">註冊成功！</div>
                  <div class="register_success"></div>
                  <div class="font_18_400">
                    <div >系統已發送帳號確信到您的email信箱</div>
                    <div>{values.USER_EMAIL}</div>
                  </div>
                  <div class="margin_t30 ">
                    <a class="font_18_500 font_green" style={{ cursor: "pointer", color: isRunning ? "gray" : "#0a58ca" }} onClick={() => { ReSendMail(values.USER_EMAIL) }} >重發確認信{isRunning && <span> ({timeLeft}秒)</span>}</a>
                  </div>
                </div>
              </>
            );
          }}
        </Formik>
      </div>
    </div >
  );
};

export default Register;
